<template>
  <div class="auth-form">
    <img
      class="mt-3 mb-2"
      :src="asset('imgs/zuulOS.png')"
      alt="Zuul Logo"
      width="100"
      height="23"
    />
    <hr />
    <b-form @submit.prevent="onLogIn" @keyup.enter="onLogIn">
      <h1 class="mt-2 mb-4">Sign in</h1>
      <error-alert v-if="hasNoAccess" class="mb-4" :errors="accessError" />
      <error-alert :errors="errors" class="mb-4" />
      <b-form-input
        v-model="email"
        type="email"
        required
        class="mb-3"
        placeholder="Email address"
        autofocus
      />
      <div class="password-input mb-2" data-recording-ignore="mask">
        <b-form-input
          v-model="password"
          required
          class="mb-2"
          :type="showPassword ? 'text' : 'password'"
          placeholder="Password"
        />
        <button
          type="button"
          class="btn btn-link link-black"
          @click.prevent="onPasswordShow"
        >
          <span class="icon">
            <img
              v-if="showPassword"
              :src="asset('/imgs/icons/show.png')"
              alt="show"
              title="Show"
            />
            <img
              v-else
              :src="asset('/imgs/icons/hide.png')"
              alt="Hide"
              title="Hide"
            />
          </span>
        </button>
      </div>
      <b-link class="mt-2 mb-3 float-right" to="/forgot-password"
        >Forgot your password?</b-link
      >
      <b-button variant="primary" type="submit" class="w-100 mb-3">
        <template v-if="loading">
          <button-loader />
        </template>
        <template v-else>Sign in</template>
      </b-button>
    </b-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ButtonLoader from '../../components/ButtonLoader';
import ErrorAlert from '../../components/ErrorAlert.vue';
import SessionAPI from '../../services/SessionAPI';

export default {
  name: 'LoginPage',
  components: {
    ButtonLoader,
    ErrorAlert,
  },
  data() {
    return {
      loading: false,
      email: null,
      password: null,
      showPassword: false,
      errors: {},
      accessError: {
        access: [
          "Sorry, looks like you don't have permissions to view Portal. Please contact hello@zuul.com if you feel this is a mistake.",
        ],
      },
    };
  },
  computed: {
    ...mapGetters('session', ['isAuthenticated', 'hasNoAccess']),
  },
  methods: {
    onPasswordShow() {
      this.showPassword = !this.showPassword;
    },
    onLogIn() {
      const me = this;
      const { email } = me;
      const { password } = me;

      me.errors = {};
      me.loading = true;

      SessionAPI.logIn(email, password).then((response) => {
        if (response.access_token) {
          me.$store.dispatch('session/loggedIn', response.access_token);
        } else {
          me.errors = {
            password: [
              'Email address or password is incorrect. Please try again.',
            ],
          };
          me.$store.dispatch('session/resetNoAccess');
          me.loading = false;
        }
      });
    },
  },
};
</script>
